// ══════════════════════════════════════════════════════════════════════════════════════════════
//  B-176 · ¿ES ESTA LA EDICIÓN LOCAL DE BIANGO? (24-oct-2026, t456)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  En la edición local (Biango instalado en el ordenador de la clínica, sin internet: backend/services/edicionLocal) el
//  servidor manda en GET /api/config-cliente `edicion_local`: las pantallas que no están en esta edición (`fuera`) y el estado
//  de su licencia. hooks/useBranding lo apunta aquí; lo leen el menú lateral (components/Layout · moduloVisible), el panel de
//  administración (components/AdminLayout) y el aviso de la licencia (components/AvisoEdicionLocal).
//
//  EN LA NUBE EL CAMPO NO VIENE: `fueraDeLaEdicion` contesta siempre que no y el menú queda exactamente como estaba.
//  SIN IMPORTS, A PROPÓSITO (como utils/funcionesEstado): lo cargan de verdad las guardias del menú.
let estado = null
const oyentes = new Set()

export function ponerEdicionLocal(x) {
  estado = x && typeof x === 'object' && Array.isArray(x.fuera)
    ? { fuera: new Set(x.fuera.filter((r) => typeof r === 'string')), licencia: x.licencia && typeof x.licencia === 'object' ? x.licencia : null,
        copias: x.copias && typeof x.copias === 'object' ? x.copias : null }
    : null
  for (const f of [...oyentes]) { try { f() } catch (_) { /* un oyente roto no para a los demás */ } }
  return estado
}

// ¿Es la edición local? (false en la nube y mientras no ha contestado el servidor.)
export function esEdicionLocal() {
  return estado !== null
}

// ¿Esta dirección de la aplicación NO está en la edición local? Vale la dirección entera (`/ajustes?area=facturacion`, un
// área de Ajustes) o sin sus parámetros (`/automatismos?x=1` es `/automatismos`).
export function fueraDeLaEdicion(ruta) {
  if (!estado) return false
  const entera = String(ruta || '')
  const r = entera.split('?')[0].replace(/\/+$/, '') || '/'
  return estado.fuera.has(entera) || estado.fuera.has(r)
}

// El estado de la licencia que mandó el servidor (o null).
export function licenciaLocal() {
  return estado ? estado.licencia : null
}

// t459 · las copias de seguridad: { aviso: null | 'fallo' | 'nunca' | 'vieja', texto, ultima_buena } (o null).
export function copiasLocal() {
  return estado ? estado.copias : null
}

export function suscribirEdicionLocal(f) {
  oyentes.add(f)
  return () => { oyentes.delete(f) }
}

// Lo que pide un dibujo de React (useSyncExternalStore): cambia cada vez que llega el estado.
export function fotoEdicionLocal() {
  if (!estado) return ''
  const l = estado.licencia || {}
  const c = estado.copias || {}
  return [l.estado || '', l.valida_hasta || '', l.dias_que_quedan == null ? '' : l.dias_que_quedan, [...estado.fuera].sort().join(','), c.aviso || '', c.ultima_buena || ''].join('|')
}
